/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

/**
 * The Operation status.
 */
export enum OperationStatus {
  Idle = "IDLE",
  Pending = "PENDING",
  Succeeded = "SUCCEEDED",
  Failed = "FAILED",
}
